import { doc, getDoc, setDoc } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import { IAdmin } from '@leedpulse-monorepo/interfaces';

async function createAdmin(
  admin: IAdmin,
  auth: Authentication
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new CreateAdminFailure('Unauthorized', 'unauthorized');
  }

  if (admin.id === '') {
      throw new CreateAdminFailure('Les informations sont incomplètes');
  }

  // Clean the object from undefined values
  admin = Object.fromEntries(Object.entries(admin).filter(([_, value]) => value !== undefined)) as IAdmin;

  try {
    const db = firestore;

    // First we check if the number already exists
    // If it does, we throw an error
    const adminDocRef = doc(db, FirestoreCollections.admins, admin.id);
    const adminDocSnap = await getDoc(adminDocRef);

    if (adminDocSnap.exists()) {
      throw new CreateAdminFailure('Admin already exists', 'admin-exists');
    }

    // If it doesn't, we create the number
    await setDoc(adminDocRef, admin as Record<string, any>);

    return;
  } catch (e) {
    console.log('error: ', e);
    throw new CreateAdminFailure();
  }
}

export class CreateAdminFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default createAdmin;
